define('views/shop/google_map',[
    'backbone',
    'text!views/merchants/gmap.html',
    'views/_base/baseview',
    'views/merchants/map/control',
    'views/map/name_infowindowcontent',
    'views/map/name_infowindow',
    'deepmerge'
], function (Backbone, Template, BaseView, ControlBtn, NameInfoWindowContent, NameInfoWindow, Merge) {
    'use strict';

    return BaseView.extend({
        id       : 'google-map',
        tagName  : 'section',
        template : _.template(Template),
        isRender : true,
        needsAuth: false,
        events   : {},

        initialize: function(options){

            this.merchant = null;
            this.search_data = options.search_data;
            this.view = options.view;
            this.parentView = options.parentView;

            this.current_position = {};

            // console.log('google_map initialize', this, options);
            
            // Adjust search_data
            if(this.search_data.loc){

                var latlng = this.search_data.loc,
                    lat = latlng.slice(1,latlng.indexOf(',')),
                    lng = latlng.slice(latlng.indexOf(',')+1,latlng.indexOf(']'));
                
                this.current_position.LAT = Number(lat);
                this.current_position.LON = Number(lng);

            } else if(this.view == 'merchantdetail'){

                this.current_position.LAT = Number(this.search_data.LAT);
                this.current_position.LON = Number(this.search_data.LON);

            }

            // On the Merchant Detail view we are passed a single object but we need to put it in an array
            this.locations = (Array.isArray(options.locations)) ? options.locations : [options.locations];

            // Based on view context, we determine the correct instance of the map
            if(this.view == 'merchants'){
                this.map = pf.maps.merchantView;
                // TODO: 
                this.mapMarkerCollection = pf.maps.merchantViewMarkerCollection;
            } else if(this.view == 'merchantdetail'){
                this.map = pf.maps.merchantDetailView;
                this.mapMarkerCollection = pf.maps.merchantDetailViewMarkerCollection;
            }

            this.infowindow = pf.maps.infowindow;

            BaseView.prototype.initialize(this);
        },

        render: function() {
            var that = this,
                single_location = (this.locations.length == 1);
            
            this.$el.html(this.template());

            this.map_container = this.$('.mapContainer');
            this.parent_container = this.map_container.parent();
            this.map_container.html('');
            
            if(!this.map){
                
                this.renderMap(single_location);

            } else {
                // TODO: Check to see if the Merchant Collection has changed, if so load new Merchants and markers
                // If Google Map already exists, then clear all previous markers, create a new InfoWindow and add new markers
                this.modifyAllMarkers('remove');

                this.addMarkers(single_location);

                this.map_container.html(this.map.getDiv());

                if(this.infowindow){
                    this.infowindow.close();
                }

                // Remove any existing marker InfoWindow's after map has been added to dom and the re-create it for use within new merchant results
                setTimeout(function(){

                    // $('.mapContainer .map-info-window-container').remove();
                    that.createInfoWindow();

                }, 1500);
            }

            // Allow closure of InfoWindow when Google Map is clicked
            this.map.addListener('click',function(){
                that.onMapClick();
            });

            // Because of the fluid layout and re-use of map, we need to resize/refresh the content to avoid blank map
            setTimeout(function(){

                that.resizeMap(single_location);

                // if(!oneLocation && freshMapLoad){
                //     that.resizeMap(that,that.map,that.locations,that.current_position,oneLocation);
                // }

            }, 1700);

            return this;
        },

        getPosition: function(merchant){
            var position = {};

            if(merchant && merchant.Location || merchant && merchant.Latitude){
                if(merchant.Location){
                    var location = merchant.Location;

                    position.lat = Number(location.slice(0, location.indexOf(',')));
                    position.lng = Number(location.slice(location.indexOf(',') + 1));
                } else if(merchant.Latitude){
                    position.lat = Number(merchant.Latitude);
                    position.lng = Number(merchant.Longitude);
                }
                

            } else if(this.current_position.loc){

                var latlng = this.current_position.loc,
                    lat = latlng.slice(1,latlng.indexOf(',')),
                    lng = latlng.slice(latlng.indexOf(',')+1,latlng.indexOf(']'));
                
                position.lat = Number(lat);
                position.lng = Number(lng);

            } else if(this.current_position.LAT){

                position.lat = Number(this.current_position.LAT);
                position.lng = Number(this.current_position.LON);

            } else {

                // TODO: May need to get the location of the first merchant if it's zipcode search
                position.lat = 34.41674;
                position.lng = -118.57515;

            }

            return position;
        },

        renderMap: function(single_location){
            var that = this,
                map_container = this.map_container[0],
                zoom_in_control = new ControlBtn({ type: 'zoomIn' }),
                zoom_out_control = new ControlBtn({ type: 'zoomOut' }),
                position = (single_location) ? this.getPosition(this.locations[0]) : this.getPosition(),
                map_center = new google.maps.LatLng(position.lat,position.lng),
                map_options = {
                    // center: map_center,
                    minZoom: 8,     // Max zoom out distance
                    maxZoom: 16,    // Max zoom in distance
                    zoom: 8,       // Default Zoom
                    disableDefaultUI: true,
                    scrollwheel: false,
                    clickableIcons: false,
                    styles: [
                        {
                            elementType: 'geometry',
                            stylers: [{ color: '#f6f7fb' }]
                        },
                        {
                            elementType: 'labels.text.stroke',
                            stylers: [{ color: '#f6f7fb' }]
                        },
                        {
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#eef0f4'}]
                        },
                        {
                            featureType: 'administrative.locality',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#9ca5b3'}]
                        },
                        {
                            featureType: 'poi',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#9ca5b3'}]
                        },
                        {
                            featureType: 'poi.park',
                            elementType: 'geometry',
                            stylers: [{ color: '#e1e4e6' }]
                        },
                        {
                            featureType: 'poi.park',
                            elementType: 'labels.text.fill',
                            stylers: [{ color: '#e1e4e6' }]
                        },
                        {
                            featureType: 'road',
                            elementType: 'geometry',
                            stylers: [{ color: '#e1e4e6' }]
                        },
                        {
                            featureType: 'road',
                            elementType: 'geometry.stroke',
                            stylers: [{ color: '#e1e4e6' }]
                        },
                        {
                            featureType: 'road',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#9ca5b3'}]
                        },
                        {
                            featureType: 'road.highway',
                            elementType: 'geometry',
                            stylers: [{ color: '#e1e4e6' }]
                        },
                        {
                            featureType: 'road.highway',
                            elementType: 'geometry.stroke',
                            stylers: [{color: '#e1e4e6'}]
                        },
                        {
                            featureType: 'road.highway',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#9ca5b3'}]
                        },
                        {
                            featureType: 'transit',
                            elementType: 'geometry',
                            stylers: [{color: '#8c919e'}]
                        },
                        {
                            featureType: 'transit.station',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#d59563'}]
                        },
                        {
                            featureType: 'water',
                            elementType: 'geometry',
                            stylers: [{color: '#e1e4e6'}]
                        },
                        {
                            featureType: 'water',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#515c6d'}]
                        },
                        {
                            featureType: 'water',
                            elementType: 'labels.text.stroke',
                            stylers: [{color: '#e1e4e6'}]
                        }
                    ]
                };
            
            // Create Google Map instance and add it to the Map Container parent view
            this.map = new google.maps.Map(map_container, map_options);

            // Dynamically set the height
            // TODO: renderMap fires twice sending 2 different heights causing the map to be taller than intended, an overflow property is hiding this issue for now
            map_container.style.height = $('.js-merchant-map-container').height()+'px';

            // var map_width = ($('.js-merchant-map-container').width() == 0) ? 320 : $('.js-merchant-map-container').width();

            // map_container.style.width = map_width +'px';
            
            // Add the map control buttons
            // TODO: Add a control that show how many locations are currently within map
            this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(zoom_out_control.el);
            this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(zoom_in_control.el);

            this.createInfoWindow();

            this.addMarkers(single_location);

            // Bound the view of the Google Map to the first and last Merchant
            if(!single_location){
                this.resetBounds();
            }
            
            // Set Google Map Events
            google.maps.event.addDomListener(zoom_in_control.el, 'click', function(){
                zoom_in_control.zoomIn(that.map);
            });
            google.maps.event.addDomListener(zoom_out_control.el, 'click', function(){
                zoom_out_control.zoomOut(that.map);
            });

            // Updating the relative Map object to save the Google Map reference
            if(this.view == 'merchants'){
                pf.maps.merchantView = this.map;
            } else if(this.view == 'merchantdetail'){
                pf.maps.merchantDetailView = this.map;
            }

            pf.maps.current = this.map;
        },

        updateLocation: function(current_position){
            this.current_position = current_position;
        },

        centerMap: function(center){

            if(this.map){
                var position = this.getPosition(),
                    center = new google.maps.LatLng(position.lat,position.lng);
                
                this.map.setCenter(center);
            }

        },

        // Externally access Function
        updateMap: function(locations, data){

            this.modifyAllMarkers('remove');

            if(data.loading_more){
                this.locations = this.locations.concat(locations);
            } else {
                this.locations = locations;
            }

            var single_location = (this.locations.length == 1) ? true : false;

            if(this.locations.length > 0){
                this.addMarkers(single_location);
            }

        },

        addMarkers: function(single_location){
            var that = this;
            
            // TODO: pulsating gif graphic or svg
            if(!single_location){

                var position = this.getPosition(),
                    center = new google.maps.LatLng(position.lat,position.lng),
                    current_location_marker = new google.maps.Marker({
                        animation: google.maps.Animation.DROP,
                        position : position,
                        map      : this.map,
                        icon     : 'img/maps/current_location.png',
                        title    : 'Current Location'
                    });

                this.map.setCenter(center);

                this.map.setZoom(12);

            } else {

                // Not sure why this exits, but keep it here for now
                if(this.locations.length == 1){

                    var merchant_position = this.getPosition(),
                        center = new google.maps.LatLng(merchant_position.lat,merchant_position.lng);
                    
                    // google.maps.event.trigger(this.map, 'resize');
                    this.map.setCenter(center);

                    this.map.setZoom(16);

                }

            }

            // Loop through each Merchant Location to create marker and add to current map
            for(var i = 0; i < this.locations.length; i++){
                var merchant = this.locations[i],
                    position = this.getPosition(merchant);

                if(this.locations.length == 1){
                    var marker_icon = this.getMarkerIcon(merchant, true);
                } else {
                    var marker_icon = this.getMarkerIcon(merchant);
                }

                // TODO: Create Marker Class
                var marker = new google.maps.Marker({
                    // animation : google.maps.Animation.DROP,
                    draggable: false,
                    position : position,
                    icon     : marker_icon,
                    merchant : merchant
                });
                
                // Attach click event to each Merchant Marker to show InfoWindow
                this.attachMarkerToMerchant(marker,merchant);

                // Add Merchant Marker to the current map
                marker.setMap(this.map);
                
                // Add Merchant Marker to a collection for direct access via Merchant GUID
                // var guid = (merchant.attributes.GUID) ? merchant.attributes.GUID : merchant.attributes.MerchantGUID;
                var guid = merchant.MerchantGUID;

                if(this.search_data){
                    var index = (this.search_data.PN) ? this.search_data.PN : 0;
                } else {
                    var index = 0;
                }

                // Allow the search page number to be the key of each collection of merchant markers
                if(_.isEmpty(this.mapMarkerCollection[index])){
                    this.mapMarkerCollection[index] = {};
                }

                this.mapMarkerCollection[index][guid] = marker;

            }

            // setTimeout(function(){
            //     console.log('addMarkers, resizing map',that.map,google.maps);
            //     that.resizeMap();
            // }, 1000);

        },

        getMarkerIcon: function(merchant, active){
            var active = (active) ? '-active' : '',
                agid = (merchant.attributes) ? merchant.attributes.AggregatorID : merchant.AggregatorID;

            if(agid == enums.aggregatorID.Blackhawk){
                return 'img/maps/scan' + active + '-map-icon.png';
            } else if(agid == enums.aggregatorID.Empyr){
                return 'img/maps/swipe' + active + '-map-icon.png';
            } else if(agid == enums.aggregatorID.Print){
                return 'img/maps/print' + active + '-map-icon.png';
            } else if(agid == enums.aggregatorID.Priceline){
                return 'img/maps/book' + active + '-map-icon.png';
            } else {
                // return 'img/maps/location_pin.png';
                return 'img/maps/swipe' + active + '-map-icon.png';
            }

        },

        attachMarkerToMerchant: function(marker, merchant){
            var that = this;

            marker.addListener('click', function() {
                that.showInfoWindow(merchant,true);
            });
            marker.addListener('mouseover', function() {
                that.showInfoWindow(merchant,true);
            });
            // marker.addListener('mouseout', function() {
            //     that.hideInfoWindow(merchant,true);
            // });
        },

        onMapClick: function(){
            var info_window = this.infowindow.getMap();

            if(info_window !== null && typeof info_window !== "undefined"){

                this.modifyAllMarkers('reset');
                this.infowindow.close();

            }
        },

        resetBounds: function(){
            if(!this.locations.length){
                return false;
            }
            
            var that = this,
                first_location = _.first(this.locations),
                last_location = _.last(this.locations),
                legacy = (first_location.Location) ? false : true,
                bounds = new google.maps.LatLngBounds();

            // TODO: Create a smarter bound/zoom to be able to see user's current location better
            var firstLAT = (legacy) ? Number(first_location.attributes.Latitude) : Number(first_location.Location.slice(0,first_location.Location.indexOf(','))),
                firstLNG = (legacy) ? Number(first_location.attributes.Longitude) : Number(first_location.Location.slice(first_location.Location.indexOf(',')+1)),
                lastLAT = (legacy) ? Number(last_location.attributes.Latitude) : Number(last_location.Location.slice(0,last_location.Location.indexOf(','))),
                lastLNG = (legacy) ? Number(last_location.attributes.Longitude) : Number(last_location.Location.slice(last_location.Location.indexOf(',')+1)),
                closestLocation = new google.maps.LatLng(firstLAT,firstLNG),
                furthestLocation = new google.maps.LatLng(firstLAT,firstLNG);

            bounds.extend(furthestLocation);
            bounds.extend(closestLocation);

            // for(var i = 0; i < this.locations.length; i++){
            //     var location = this.locations[i],
            //         lat = (legacy) ? Number(location.attributes.Longitude) : Number(location.Location.slice(location.Location.indexOf(',')+1)),
            //         lng = (legacy) ? Number(location.attributes.Latitude) : Number(location.Location.slice(0,location.Location.indexOf(','))),
            //         merchant_location = new google.maps.LatLng(lat,lng);

            //     bounds.extend(merchant_location);
            // }

            this.map.fitBounds(bounds);
            // Temporary solution to set desired zoom.  Make bound setting smarter to remove this solution.
            this.map.setZoom(12);
        },

        resizeMap: function(){
            // If there is only one location we set the center of the map
            if(this.locations.length == 1){
                var position = this.getPosition(this.locations[0]);
                var center = new google.maps.LatLng(position.lat,position.lng);
                // if(me.view != 'merchantdetail'){}
                google.maps.event.trigger(this.map, 'resize');
                this.map.setCenter(center);
            } else {
                // TODO: resetBounds fires twice in some scenarios, fix later, but keep to prevent jittery transitions
                this.resetBounds();
            }
        },

        createInfoWindow: function(){
            var that = this;

            if(!this.infowindow){
                // Instantiate one InfoWindow to be used for all Merchant markers
                this.infowindow = new NameInfoWindow({ map: this.map });

                pf.maps.infowindow = this.infowindow;
            }
            
        },

        modifyAllMarkers: function(intent, ommission){
            var collection = this.mapMarkerCollection;

            for(var key in collection){
                var markerCollection = collection[key];

                for(var id in markerCollection){

                    var marker = markerCollection[id];

                    if(intent == 'remove'){

                        // if(id == 0){
                        //     console.log('modifyAllMarkers collection intent remove', marker);
                        // }

                        // marker.setVisible(false);
                        
                        marker.setMap(null);

                    } else if(intent == 'reset'){

                        // if(ommission){

                        //     // By choosing to omit the Merchant that is in focus we want to provide the active marker icon, otherwise provide the standard marker icon
                        //     if(ommission.MerchantGUID == marker.merchant.MerchantGUID){
                        //         var marker_icon = this.getMarkerIcon(marker.merchant, true);
                        //     } else {
                        //         var marker_icon = this.getMarkerIcon(marker.merchant);
                        //     }

                        // } else {
                        //     var marker_icon = this.getMarkerIcon(marker.merchant);
                        // }

                        // marker.setMap(null);

                        // marker.setIcon(marker_icon);

                        // marker.setMap(this.map);
                    }
                }
            }

            if(intent == 'remove'){
                pf.maps.resetMerchantViewCollection(this.mapMarkerCollection);
            }

        },

        showInfoWindow: function(model,markerEvent){
            if(!model || !this.infowindow){
                return false;
            }
            var isDetailView = (!model.attributes.Percent) ? true : false,
                guid = (isDetailView) ? model.attributes.MerchantGUID : (model.MerchantGUID) ? model.MerchantGUID : model.GUID,
                merchant = (isDetailView) ? model.attributes : model,
                imgURL = (isDetailView) ? merchant.Logo : merchant.attributes.LogoURL,
                name = (isDetailView) ? merchant.MerchantGroupName : merchant.MerchantGroupName,
                address = merchant.AddressLine1 +', '+merchant.City,
                distance = Number(merchant.Distance).toFixed(2),
                rebate = merchant.CurrentRebatePercentage,
                // Detail view description is undefined at times
                description = (isDetailView) ? '' : merchant.ShortDescription,
                MGUID = (isDetailView) ? merchant.MerchantGroupGUID : merchant.MerchantGroupGUID,
                GUID = (isDetailView) ? merchant.MGID : merchant.GUID,
                AGUID = (isDetailView) ? merchant.AggregatorID : merchant.AggregatorID,
                data = {
                    name    : name
                },
                new_data = {
                    name    : merchant.Name
                };

            new_data = Merge(model.attributes,new_data);

            data = Merge(model.attributes,data);

            if(isDetailView){
                var marker = this.mapMarkerCollection[0][guid];
                var content = new NameInfoWindowContent(data)
            } else {
                var marker = this.mapMarkerCollection[0][guid];
                var content = new NameInfoWindowContent(new_data);
            }

            // Reset all markers currently showing to default icon
            this.modifyAllMarkers('reset',model);

            // Remove current marker
            // marker.setMap(null);

            // Change selected marker icon
            this.showActiveMarker(model, marker);

            this.infowindow.setContent(content.el.outerHTML);
            this.infowindow.show(marker, markerEvent, model);

            // Send data to parent view if event stems from a map marker event
            if(markerEvent){
                this.parentView.onMerchantMapHover(model);
            }
        },

        hideInfoWindow: function(model){
            if(!model || !this.infowindow){
                return false;
            }
            this.hideActiveMarker(model);
            this.infowindow.close();
        },

        showActiveMarker: function(model){
            if(!model){
                return false;
            }

            var guid = (model.attributes.MerchantGUID) ? model.attributes.MerchantGUID : (model.MerchantGUID) ? model.MerchantGUID : model.GUID,
                index = (model.collection && model.collection.currentPage) ? model.collection.currentPage : 0,
                marker = this.mapMarkerCollection[index][guid];
            
            if(marker){

                var marker_icon = this.getMarkerIcon(model);
                // var marker_icon = this.getMarkerIcon(model, true);

                if(marker_icon){
                    marker.setIcon(marker_icon);
                } else {
                    marker.setIcon('img/maps/location_pin_hover.png');
                }
                
            }
        },

        hideActiveMarker: function(model){
            if(!model){
                return false;
            }
            var guid = (model.attributes.MerchantGUID) ? model.attributes.MerchantGUID : (model.MerchantGUID) ? model.MerchantGUID : model.GUID,
                index = (model.collection && model.collection.currentPage) ? model.collection.currentPage : 0,
                marker = this.mapMarkerCollection[index][guid];
            
            if(marker){

                var marker_icon = this.getMarkerIcon(model);
                
                if(marker_icon){
                    marker.setIcon(marker_icon);
                } else {
                    marker.setIcon('img/maps/location_pin_hover.png');
                }

            }
        }
    });
});
